import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getClusters,
  getPrecoRegra,
  getListaPrecoRegra,
  getProdutoFilialMicro,
  getPrecoProdutoFilialCliente,
  getServicosPreco,
  getSubGrupoProdutos,
  getParametros,
  setLogAcesso,
  salvarLog,
} from "~services/BackOfficeServices";
import useCacheMutation from "~hooks/useCacheMutation";

export const useGetPrecoRegra = (produtoId, filialId, microrregiaoId, enabled) => {
  const produtos = useQuery(
    ["produtoPrecoRegra", produtoId, filialId, microrregiaoId],
    () => getPrecoRegra(produtoId, filialId, microrregiaoId),
    {
      enabled: enabled,
    }
  );
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["produtoPrecoRegra", produtoId, filialId, microrregiaoId]);
  };
  return { ...produtos, clearCache };
};

export const useGetListaPrecoRegra = (produtosIds, microrregiaoId, enabled) => {
  const produtos = useQuery(
    ["produtosListaPrecoRegra", produtosIds, microrregiaoId],
    () => getListaPrecoRegra(produtosIds, microrregiaoId),
    {
      enabled: enabled,
    }
  );
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["produtosListaPrecoRegra", produtosIds, microrregiaoId]);
  };
  return { ...produtos, clearCache };
};

export const useGetPrecoServico = (idProduto, idCliente, enabled) => {
  const produtos = useQuery(["servicosPreco", idProduto, idCliente], () => getServicosPreco(idProduto, idCliente), {
    enabled: enabled,
  });
  const queryClient = useQueryClient();
  const clearCache = () => {
    queryClient.removeQueries(["servicosPreco", idProduto, idCliente]);
  };

  return { ...produtos, clearCache };
};

export const useGetProdutoFilialMicro = (id, enabled) => {
  const produtos = useQuery(["ProdutoFilialMicro", id], () => getProdutoFilialMicro(id), {
    enabled: enabled,
  });
  return produtos;
};

export const useGetPrecoProdutoFilialCliente = (clienteId, produtoFilialId, enabled) => {
  const produtos = useQuery(
    ["ProdutoFilialCliente", clienteId, produtoFilialId],
    () => getPrecoProdutoFilialCliente(clienteId, produtoFilialId),
    {
      enabled: enabled,
    }
  );
  return produtos;
};

export const useGetClusters = () => {
  const clusters = useQuery(["clusters"], () => getClusters());
  const queryClient = useQueryClient();
  const clearCache = () => {
    queryClient.removeQueries(["clusters"]);
  };
  return { ...clusters, clearCache };
};

export const useSaveLog = (onSuccess, onError) => {
  const { mutateCached } = useCacheMutation(
    salvarLog,
    "Salvar Log",
    null,
    null,
    "Log salvo com sucesso!",
    onSuccess,
    onError
  );

  const handleSave = (campos, url, status, response, stack) => {
    mutateCached(campos, url, status, response, stack);
  };

  return handleSave;
};

export const useSetLogAcesso = (location = {}, pagina, dispositivo) => {
  const { mutateCached } = useCacheMutation(
    setLogAcesso,
    "Salvar LogAcesso",
    null,
    null,
    "LogAcesso salvo com sucesso!",
    () => {},
    () => {}
  );

  const handleSave = () => {
    mutateCached({ location, pagina, dispositivo });
  };

  return handleSave;
};

export const useGetParametros = (enabled, take, skip) => {
  const parametros = useQuery(["parametros", skip, take], () => getParametros(skip, take), {
    enabled: enabled,
    retry: 0,
  });
  const queryClient = useQueryClient();
  const clearCache = () => {
    queryClient.removeQueries(["parametros", skip, take]);
    return parametros;
  };
  return { ...parametros, clearCache };
};
